import React, { useContext } from 'react';
import { PageContext } from '../providers/page-provider';
import { HealthAssesment } from '../providers/health-assesment-provider';
import { HealthAssesmentCalculator } from '../layouts/health-assesment-calculator';
import './pages.scss';
import {
  Question,
  StepSummary,
  ButtonOption,
  StepSlider
} from '../components'

export const StepThree = () => {
  const { handleNextPage, handlePreviousPage } = useContext(PageContext);
  const { addHealthAssesmentData, healthAssesmentData } = useContext(HealthAssesment);
  const titleStep = "Scalability";
  const summaryStep = "Alright, now let's capture some information on your AR processes";
  const tooltip = "The scalability of your AR operation is a key component of overall health. It measures the agility and readiness of your business to adapt to sudden changes in volume, payments, or economic conditions."

  const handleNextClick = () => {
    handleNextPage({from: "STEP_THREE", to: "STEP_FOUR"});
  }

  const handleBackClick = () => {
    handlePreviousPage({to: "STEP_TWO"});
  };

  const handleChange = (question) => (event) => {
    const { name, value } = event.target;
    addHealthAssesmentData({question, name, value});
  }

  return (
    <HealthAssesmentCalculator>
      <div className="fieldset step-three">
        <StepSummary stepNumber="3" stepTitle={titleStep} stepInfo={summaryStep} hasTooltip={true} tooltipText={tooltip}/>
        <div className="questions">
          <div className="column-left">
            <Question>What is your estimated year-over-year revenue growth rate?</Question>
            <StepSlider
              min={1}
              max={300}
              minValue="<1%"
              maxValue="300%"
              currency={false}
              valueType="%"
              name="a"
              initalValue={healthAssesmentData.scalability.a}
              onChange={handleChange("scalability")}
              idSlider="3a-slide"
              idValue="3a-value"
            />

            <Question>How many hours are spent a month for AR-specific operations (includes invoice or sales order delivery, payment collection, reconciliation, month-end close on the AR side)?</Question>
            <StepSlider
              min={1}
              max={120}
              minValue="<1h"
              maxValue="120h+"
              currency={false}
              valueType="h"
              name="b"
              initalValue={healthAssesmentData.scalability.b}
              onChange={handleChange("scalability")}
              idSlider="3b-slide"
              idValue="3b-value"
            />
          </div>
          <div className="column-right">
            <div className="right-container">
              <Question>Is your reconciliation automated or is it a manual process?</Question>
              <div className="btn-container">
                <ButtonOption
                  name="c"
                  checked={healthAssesmentData.scalability.c === "automated"}
                  onChange={handleChange("scalability")}
                  value="automated"
                  id="automated"
                />

                <ButtonOption
                  name="c"
                  checked={healthAssesmentData.scalability.c === "manual"}
                  onChange={handleChange("scalability")}
                  value="manual"
                  id="manual"
                />
              </div>

              <Question>Can invoices be paid with "Pay Now" button?</Question>
              <div className="btn-container">
                <ButtonOption
                  name="d"
                  checked={healthAssesmentData.scalability.d === "yes"}
                  onChange={handleChange("scalability")}
                  value="yes"
                  id="paybtnYes"
                />
                <ButtonOption
                  name="d"
                  checked={healthAssesmentData.scalability.d === "no"}
                  onChange={handleChange("scalability")}
                  value="no"
                  id="paybtnNo"
                />
              </div>
            </div>
          </div>

          <footer>
            <button className="btn-white-normal-back" onClick={handleBackClick}><i className="fa fa-angle-left"></i> Back</button>
            <button className="btn-white-normal" onClick={handleNextClick}>Next Step <i className="fa fa-angle-right"></i></button>
          </footer>
        </div>
      </div>
    </HealthAssesmentCalculator>
  )
}
